<template>
    <div>
        <reg-base-header-sec></reg-base-header-sec>
        <!--        {{loaded}}-->
        <div class="container-fluid base-container">
            <div class="base-box p-normal">

                <iframe :style="iframeStyle" @load="load" ref="ifr" id="ifr" class="static-iframe" width="100%"
                    :src="baseApiUrl + 'prins/static/page/reg/' + $route.query.page" frameborder="0"></iframe>
            </div>
        </div>
    </div>
</template>

<script>

import RegBaseHeaderSec from '@/base_pages/reg/RegBaseHeaderSec.vue';


export default {
    name: "BaseStaticPage",
    data() {
        return {
            iframeStyle: {
                height: '800px',
            },
            loaded: false,
            baseApiUrl: window.env.VUE_APP_API_FP_DEV,
             
            meta: {
                title: 'Правно-информациони систем РС',
                description: 'Правно-информациони систем je збирка података у електронском облику која садржи: електронски облик Службеног гласника, архиву службених гласила, базу која садржи регистар и текстове важећих прописа и других аката Републике Србије објављених у Службеном гласнику, базу која садржи судску праксу, друге податке о правном систему Републике Србије и везу с правним актима Европске уније.',
                keywords: 'zakoni, akti, zakonski, propisi, sudska praksa, registar, odluka, sudovi, ugovori, pravno informacioni sistem, prins, pis,sluzbeni glasnik',
            },
        }
    },
    metaInfo() {
        return {
            title: this.meta.title,
            meta: [
                { name: 'title', content: this.meta.title },
                { name: 'description', content: this.meta.description },
                { name: 'keywords', content: this.meta.keywords },
            ],
        }
    },
    watch: {
        $route() {
            if (this.$route.query.page === 'contact' || this.$route.query.page === 'impresum') {
                this.iframeStyle.height = '440px';
            } else {
                this.iframeStyle.height = '600px';
            }
        }
    },
    computed: {},
    methods: {
        load: function () {
            this.loaded = true;
            // setTimeout(iResize, 50);
            // console.log(this.$refs['ifr']);
            //
            // this.iframeStyle.height = this.$refs['ifr'].contentWindow.document.body.offsetHeight + 'px';
        }
    },
    components: {
        RegBaseHeaderSec,
    },
    mounted() {
        if (this.$route.query.page === 'contact' || this.$route.query.page === 'impresum') {
            this.iframeStyle.height = '440px';
        } else {
            this.iframeStyle.height = '600px';
        }
    },
    beforeCreate: function () {
        document.body.className = 'color_reg';
    }
}
</script>

<style scoped>
.static-iframe {
    height: 800px;
}
</style>
